import { useState } from 'react';
import { useAuth } from '../auth';
import { useT, type Lang } from '../i18n';
import PageHeader from '../components/PageHeader';
import ChangePassword from './ChangePassword';
import { getTheme, setTheme, type Theme } from '../theme';

export default function Settings() {
  const { user, signOut } = useAuth();
  const { t, lang, setLang } = useT();
  const [theme, setThemeState] = useState<Theme>(getTheme());
  function toggleTheme(x: Theme) { setTheme(x); setThemeState(x); }

  return (
    <>
      <PageHeader eyebrow="BB Commercial" title={t('s.title')} subtitle={t('s.sub', { u: user?.username ?? '' })} />
      <div className="grid gap-6 lg:grid-cols-2">
        <section className="card p-5 space-y-3">
          <div className="font-medium">{t('s.language')}</div>
          <div className="flex gap-2">
            {(['en', 'lv'] as Lang[]).map((l) => (
              <button key={l} className={lang === l ? 'btn-primary' : 'btn-secondary'} onClick={() => setLang(l)}>{l === 'en' ? 'English' : 'Latviešu'}</button>
            ))}
          </div>
          <div className="font-medium pt-2">{t('s.appearance')}</div>
          <div className="flex gap-2">
            {(['dark', 'light'] as Theme[]).map((x) => (
              <button key={x} className={theme === x ? 'btn-primary' : 'btn-secondary'} onClick={() => toggleTheme(x)}>{t(x === 'dark' ? 'theme.dark' : 'theme.light')}</button>
            ))}
          </div>
          <div className="text-xs text-dim">{t('s.install')}</div>
        </section>
        <section className="card p-5 space-y-3">
          <div className="font-medium">{t('s.password')}</div>
          <ChangePassword />
        </section>
        <section className="card p-5">
          <button className="btn-danger" onClick={signOut}>{t('login.signout')}</button>
        </section>
      </div>
    </>
  );
}
